<script>
import Dialog from './Dialog.vue'
export default {
    components: {
        Dialog
    }
}
</script>

<template>
    <Dialog hide-close @confirm="$emit('confirm')" >
        <p class="p" >请拨打客服电话 “400-699-3233”</p>
    </Dialog>
</template>

<style lang="scss" scoped>
.p {
    margin-left: auto;
    margin-right: auto;
    width:160px;
    height:42px;
    font-size:16px;
    color:rgba(52,52,52,1);
    line-height:21px;
    text-align: center;
    margin-bottom: 52px;
}
</style>





// WEBPACK FOOTER //
// yotta-vue-components/vision/ForgotPwdDialog.vue